import { NotificationType } from '@/types/common';
import { createContext, useContext } from 'react';

type NotificationContextType = {
  notify: (
    type: NotificationType,
    message: string,
    description?: string
  ) => void;
};

export const NotificationConText =
  createContext<NotificationContextType | null>(null);

export const useNotification = (): NotificationContextType => {
  const context = useContext(NotificationConText);
  if (!context) {
    throw new Error(
      'useNotification must be used within a NotificationProvider'
    );
  }
  return context;
};
